// safe-remove-child.js — colocar al inicio de index.tsx (antes de ReactDOM.render)
(function() {
    const origRemoveChild = Node.prototype.removeChild;
  
    Node.prototype.removeChild = function(child) {
      try {
        // si el child no es hijo directo, tratamos de encontrar un "igual"
        if (child && child.parentNode !== this) {
          // buscamos un nodo equivalente usando isEqualNode
          for (const node of Array.from(this.childNodes)) {
            try {
              if (node.isEqualNode && node.isEqualNode(child)) {
                return origRemoveChild.call(this, node);
              }
            } catch (e) { /* ignore */ }
          }
          // si no encontramos, no lanzamos — solo logueamos y devolvemos el child (sin crash)
          console.warn('safeRemoveChild: node not a child, ignoring removeChild to avoid crash', child);
          return child;
        }
        return origRemoveChild.call(this, child);
      } catch (err) {
        console.error('safeRemoveChild caught error', err);
        // seguro: no dejar que rompa la app
        return child;
      }
    };
  })();
  